import React, { FC, useEffect, useRef} from 'react';

type EchartProps = {
  option: {[key: string]: any};
  trigger: number;
  height: number
}
declare const echarts: {init: Function};
const Echart: FC<EchartProps> = ({ option, trigger, height }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!chartRef.current || !trigger) return;
    const chart = echarts.init(chartRef.current);
    chart.setOption(option);
    window.addEventListener('resize', () => chart.resize());
  }, [trigger])

  return ( <div style={{ width: '100%', height }} ref={chartRef}></div>)
}

export default Echart;
